export const ROUTER_REDUCER = 'router';
